import { BusinessDayComponent } from 'app/calendar/business-day/business-day.component';
import { SalaAttesaComponent } from 'app/calendar/sala-attesa/sala_attesa';
import { WelcomeComponent } from 'app/home/welcome/welcome';
import { LoginComponent } from 'app/login/login';
import { HomeComponent } from './home/home';

import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AnagraficaComponent } from 'app/anagrafica/anagrafica';
import { RubricaComponent } from 'app/rubrica/rubrica';
import { AppuntamentiSpecialisticheComponent } from "./components/appuntamenti-specialistiche/appuntamenti-specialistiche";
import { AppuntamentoSpecialisticoComponent } from "./components/appuntamento-specialistico/appuntamento-specialistico";
import { ResetFormComponent } from './opzioni/reset-form/reset-form';

const routes: Routes = [
	{
		path: 'login',
		component: LoginComponent
	},
	{
		path: 'app-spe',
		component: HomeComponent,
		children: [
			{
				path: '',
				component: AppuntamentiSpecialisticheComponent
			},
			{
				path: 'edit',
				component: AppuntamentoSpecialisticoComponent
			}
		]
	},
	{
		path: 'reset',
		component: ResetFormComponent
	},
	{
		path: 'agende/:codice_fiscale/:agenda',
		component: HomeComponent,
		children: [
			{
				path: 'orario',
				component: BusinessDayComponent
			},
			{
				path: 'waiting',
				component: SalaAttesaComponent
			},
			{
				path: 'anagrafica',
				component: AnagraficaComponent
			}
		]
	},
	{
		path: 'rubrica',
		component: HomeComponent,
		children: [
			{
				path: '',
				component: RubricaComponent
			}
		]
	},
	{
		path: 'agende',
		component: HomeComponent,
		children: [
			{
				path: '',
				component: WelcomeComponent
			}
		]
	},
	{
		path: '**',
		redirectTo: 'agende'
	}
];

@NgModule({
	imports: [RouterModule.forRoot(routes)],
	exports: [RouterModule]
})
export class AppRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts